import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransferAgent } from '../../hooks/useTransferData';
import styles from './TransferPanelList.module.css';

interface TransferAgentTabProps {
  agents: TransferAgent[];
  filteredAgents: TransferAgent[];
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSelectAgent: (agent: TransferAgent) => void;
}

export function TransferAgentTab({
  agents,
  filteredAgents,
  searchQuery,
  onSearchChange,
  onSelectAgent,
}: TransferAgentTabProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.searchBox}>
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
        <input
          type="text"
          placeholder={t('call:transfer.searchAgents')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.list}>
        {filteredAgents.length === 0 ? (
          <div className={styles.emptyState}>
            {agents.length === 0
              ? t('call:transfer.noAgentsAvailable')
              : t('call:transfer.noMatchingAgents')}
          </div>
        ) : (
          filteredAgents.map((agent) => (
            <button
              key={agent.agentId}
              className={styles.listItem}
              onClick={() => onSelectAgent(agent)}
            >
              <div
                className={`${styles.itemIcon} ${agent.isAvailable ? styles.available : styles.unavailable}`}
              >
                {agent.firstName.charAt(0) || agent.agentName.charAt(0)}
              </div>
              <div className={styles.itemText}>
                <span className={styles.itemName}>{agent.agentName}</span>
                <span className={styles.itemMeta}>
                  {agent.state}
                  {agent.teamName && ` • ${agent.teamName}`}
                </span>
              </div>
              <svg
                className={styles.itemArrow}
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="currentColor"
              >
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
              </svg>
            </button>
          ))
        )}
      </div>
    </>
  );
}
